import Vue from 'vue';
import Router from 'vue-router';
import Component from 'vue-class-component';

// service
import LoginService from '@/core/services/login.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({})
export default class HeaderComponent extends Vue {
  showLoggoutMenu: boolean = false;
  loginService: any = new LoginService();
  sidebarService: any = new SidebarService();
  name: string = "";
  surname: string = "";

  mounted (){
    const _ = this;
    _.nameAdmin();
    _.surnameAdmin();
  }

  Login(){
    const _ = this;
    _.loginService.login(user).then((data: any) => {
      console.log(data);
      localStorage.setItem('tk_auth', data['data'].user.token);
      console.log(data);
      localStorage.setItem('isAdmin', data['data'].user.isAdmin);
      console.log(data);
    })
  }

  nameAdmin(){
    const _ = this;
    _.name = localStorage.getItem('admin_name');

  }

  surnameAdmin(){
    const _ = this;
    _.surname = localStorage.getItem('admin_surname');
  }

  loggout(){
    const _ = this;
    localStorage.removeItem('tk_auth');
    _.$router.push('/');
  }

  toggleSidebar(){
    const _ = this;
    _.sidebarService.toggle();
  }
}
